import { saveToStorage } from "./utilities";

function storePrintValues({
    badStart,
    goodStart,
    stableReturn,
    graphSrc,
    stateOfMarket,
    totalRetirementSavings,
    withdrawalAmount,
    withdrawalFrequency,
}) {
    stateOfMarket = stateOfMarket
        .map((value, index) => (index > 0 ? value.toLowerCase().trim() : value.trim()))
        .join(", ");
    withdrawalFrequency = withdrawalFrequency.trim();

    const value = {
        badStart,
        goodStart,
        stableReturn,
        graphSrc,
        stateOfMarket,
        totalRetirementSavings,
        withdrawalAmount,
        withdrawalFrequency,
    };

    saveToStorage("sequenceofreturns", value);
}

export { storePrintValues };
